// import logoDark from './Icon-OpticTruckWorks-03.png'
const logoDarkUrl = '/photos/icon-red-white-background.png'
const logoLightUrl = '/photos/icon-red-white-background.png'
const logoNoBackgroundUrl = '/photos/LogoVariation-OpticTruckWorks-02.png'
// import authBackground from './home.jpg'
// import stepVan from './step-van.png'
// import boxTruck from './box-truck.png'

const opticTruckBlueUrl = '/photos/icon-blue-white-background.png'
const stepVanUrl = '/photos/icon-blue-white-background.png'
const authBackgroundUrl = '/photos/auth-background.png'
const boxTruckUrl = '/photos/boxtruck.png'
// import cargoVan from './cargo-van.png'
const cargoVanUrl = '/photos/cargovan.png'
// import cutaway from './cutaway.png'
const cutawayUrl = '/photos/cutaway.png'

const preloadImage = (src: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve(src)
    img.onerror = () => {
      console.error(`Failed to preload image: ${src}`)
      reject(new Error(`Failed to preload image: ${src}`))
    }
    img.src = src
  })
}


export const preloadAllImages = async (): Promise<void> => {
  try {
    await Promise.all([
      preloadImage(authBackgroundUrl),
      preloadImage(logoLightUrl),
      preloadImage(logoDarkUrl),
      preloadImage(logoNoBackgroundUrl),
      preloadImage(opticTruckBlueUrl),
      preloadImage(stepVanUrl),
      preloadImage(boxTruckUrl),
      preloadImage(cargoVanUrl),
      preloadImage(cutawayUrl),
    ]);
  } catch (error) {
    console.error("Error preloading images:", error);
  }
};

const logoDark = logoDarkUrl
const logoLight = logoLightUrl
const logoNoBackground = logoNoBackgroundUrl
const authBackground = authBackgroundUrl
const stepVan = stepVanUrl
const boxTruck = boxTruckUrl
const cargoVan = cargoVanUrl
const cutaway = cutawayUrl
const opticTruckBlue = opticTruckBlueUrl
export {
  logoDark,
  logoLight,
  logoNoBackground,
  authBackground,
  stepVan,
  boxTruck,
  cargoVan,
  cutaway,
  opticTruckBlue,
}
